import React from 'react';
import { Link } from 'react-router-dom';
import { Bitcoin, ArrowRight } from 'lucide-react';
import { useT } from '../context/I18nContext';

const CryptoBanner = () => {
  const { t } = useT();
  return (
    <section
      data-testid="crypto-banner"
      className="relative overflow-hidden border-y border-[#d4af37]/30 bg-gradient-to-r from-black via-[#1a1408] to-black"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #d4af37 0%, transparent 40%), radial-gradient(circle at 80% 50%, #d4af37 0%, transparent 40%)' }}
      />
      <div className="relative max-w-[1480px] mx-auto px-6 py-7 flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full border-2 border-[#d4af37] flex items-center justify-center shrink-0 bg-black/60">
            <Bitcoin className="h-6 w-6 text-[#d4af37]" />
          </div>
          <div>
            <p className="text-[#d4af37] tracking-[0.3em] text-[10px] uppercase mb-1">{t('banner.eyebrow')}</p>
            <h3 className="serif-italic text-zinc-100 text-2xl md:text-3xl">
              {t('banner.title_a')} <span className="gold-gradient-text">{t('banner.title_b')}</span> {t('banner.title_c')}
            </h3>
            <p className="text-zinc-400 text-sm mt-1">{t('banner.subtitle')}</p>
          </div>
        </div>
        <Link
          to="/shop"
          data-testid="crypto-banner-cta"
          className="btn-gold inline-flex items-center gap-2 px-6 h-12 rounded tracking-wider uppercase text-sm shrink-0"
        >
          {t('banner.cta')} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
};

export default CryptoBanner;
